if (!("classList" in document.documentElement)) {
    Object.defineProperty(HTMLElement.prototype, 'classList', {
        get: function () {
            var self = this;
            function update(fn) {
                return function (value) {
                    var classes = self.className.split(/\s+/g),
                        index = classes.indexOf(value);

                    fn(classes, index, value);
                    self.className = classes.join(" ");
                }
            }

            return {
                add: update(function (classes, index, value) {
                    if (!~index) classes.push(value);
                }),

                remove: update(function (classes, index) {
                    if (~index) classes.splice(index, 1);
                }),

                toggle: update(function (classes, index, value) {
                    if (~index)
                        classes.splice(index, 1);
                    else
                        classes.push(value);
                }),

                contains: function (value) {
                    return !!~self.className.split(/\s+/g).indexOf(value);
                },

                item: function (i) {
                    return self.className.split(/\s+/g)[i] || null;
                }
            };
        }
    });
}
import '@babel/polyfill'
import Vue from 'vue'
import "classlist-polyfill"
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '../public/css/reset.css'
import MyPlugin from './utils/utils'
import moment from 'moment/moment'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "swiper/dist/css/swiper.min.css"
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import './eleconfig/element-var.scss'
import i18n from './locales'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'

Vue.filter('formatDate', function (value, formatString) {
    if (!value) {
        return value
    } else {
        formatString = formatString || 'YYYY-MM-DD HH:MM';
        // return moment(value).format(formatString); // value可以是普通日期 20170723
        return moment(value).format(formatString)
    }

});
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);
Vue.use(MintUI);
Vue.use(router)
Vue.use(VueAxios, axios)
Vue.use(MyPlugin)
Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router,
    i18n
}).$mount('#app')
